import { getABTestConfig } from '@/config/abTestConfig'
import ABTestRootOutlet from '@app-studio-web/ui/components/ABTestRootOutlet'
import skipOnboardingLoader from '@app-studio-web/ui/loaders/skipOnboardingLoader'
import createAccountRoutes from '@app-studio-web/ui/pages/account/accountRoutes'
import checkoutRoutes from '@app-studio-web/ui/pages/checkout/checkoutRoutes'
import ErrorPage from '@app-studio-web/ui/pages/ErrorPage'
import helpCenterRoutes from '@app-studio-web/ui/pages/helpCenter/helpCenterRoutes'
import LandingPage from '@app-studio-web/ui/pages/LandingPage'
import PreparingPage from '@app-studio-web/ui/pages/signUp/PreparingPage'
import signUpRoutes from '@app-studio-web/ui/pages/signUp/signUpRoutes'
import { Navigate, Outlet } from 'react-router-dom'
import { saveOnboardingAnswers } from '../actions/saveOnboardingAnswers'
import OnboardingOutlet from './baseline/onboarding/OnboardingOutlet'
import baselineOnboardingRoutes from './baseline/onboarding/routes'
import v1OnboardingRoutes from './v1/onboarding/routes'
import v2OnboardingRoutes from './v2/onboarding/routes'

const abTestConfig = getABTestConfig()

const routes = [
  {
    element: <ABTestRootOutlet abTestConfig={abTestConfig || undefined} />,
    errorElement: <ErrorPage />,
    path: '/',
    children: [
      {
        element: <LandingPage />,
        index: true,
      },
      {
        element: <Outlet />,
        path: 'account',
        children: createAccountRoutes(),
      },
      {
        element: <Outlet />,
        path: 'checkout',
        children: checkoutRoutes,
      },
      {
        element: <Outlet />,
        path: 'help-center',
        children: helpCenterRoutes,
      },
      {
        element: <OnboardingOutlet />,
        path: 'onboarding',
        loader: skipOnboardingLoader,
        children: [
          ...baselineOnboardingRoutes,
          ...v1OnboardingRoutes,
          ...v2OnboardingRoutes,
        ],
      },
      {
        element: <Outlet />,
        path: 'sign-up',
        children: signUpRoutes.map((route) => {
          if (route.path === 'preparing') {
            return {
              ...route,
              element: <PreparingPage onPrepare={saveOnboardingAnswers} />,
            }
          }
          return route
        }),
      },
      {
        element: <Navigate to="/onboarding" replace />,
        path: '*',
      },
    ],
  },
]

export default routes
